import { useEffect, useRef } from "react";
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';
import { useUserDataContext } from '../../contexts/userDataProvider';

const ModalComponent = ({
  handleClose,
  show,
  ModalContent,
  onSubmitButtonHandler,
  onSubmitButtonName,
  type,
  secondaryButtonHandler,
  secondaryButtonName,
  hideCancelButton
}) => {
  const { translate } = useUserDataContext();

  const targetRef = useRef(null);

  const scrollToTarget = () => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const getModalContet = () => {
    if (typeof ModalContent === 'function') {
      return <ModalContent />
    }

    if (typeof ModalContent === 'object') {
      return ModalContent
    } else {
      return <p>{ ModalContent }</p>
    }
  };

  useEffect(() => {
    if (show) {
      scrollToTarget();
    }
  }, [show]);

  return (
      <Modal
        centered
        open={show}
        onOk={onSubmitButtonHandler}
        onCancel={handleClose}
        className={type ==='WARNING' ? 'warning' : 'common'}
        width={{
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '90%',
          xxl: '65%',
        }}
        footer={[
          !hideCancelButton && (
            <Button
              key="cancel"
              onClick={handleClose}
            >
              {translate('cancel')}
            </Button>
          ),
          secondaryButtonHandler && (
            <Button
              key="secondary"
              type="primary"
              style={{ marginTop: 20, marginRight: 40 }}
              onClick={secondaryButtonHandler}
            >
              {secondaryButtonName}
            </Button>
          ),
          onSubmitButtonHandler && (
            <Button
              key="submit"
              type="primary"
              style={{ marginTop: 20, marginRight: 40 }}
              onClick={onSubmitButtonHandler}
            >
              {onSubmitButtonName}
            </Button>
          )
        ].filter(Boolean)}
      >
        <div ref={targetRef}>
          {getModalContet()}
        </div>
      </Modal>
  );
};

ModalComponent.propTypes = {
  handleClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  ModalContent: PropTypes.oneOfType([
    PropTypes.string, // For plain text
    PropTypes.func, // For passing a component
    PropTypes.node // For JSX or React elements
  ]).isRequired,
  onSubmitButtonHandler: PropTypes.func,
  onSubmitButtonName: PropTypes.string,
  secondaryButtonHandler: PropTypes.func,
  secondaryButtonName: PropTypes.string,
  type: PropTypes.oneOf(['WARNING']),
  hideCancelButton: PropTypes.bool
};

export default ModalComponent;
